import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"
import DoubleButton from "./DoubleButton"
import coupleSittedFaceRight350w from "./img/couple-sitted-face-right-350w.png"
import coupleSittedFaceRight700w from "./img/couple-sitted-face-right-700w.png"

const PriceGuaranteedHomepage: React.FC = () => {
  return (
    <section
      className={cx({
        [styles.priceGuaranteed]: true,
        [styles.homepage]: true,
      })}
    >
      <div className={styles.pagePadding}>
        <figure className={styles.figure}>
          <img
            className={styles.image}
            src={coupleSittedFaceRight350w}
            srcSet={`${coupleSittedFaceRight700w} 700w, ${coupleSittedFaceRight350w} 350w`}
            sizes="20vw"
            alt="Better Price Guaranteed"
          />
        </figure>
        <div className={styles.content}>
          <div className={styles.message}>
            <h2 className={styles.heading}>The Better Price Guarantee</h2>
            <p className={styles.subhead}>
              We’re confident our prices are better. If you’ve found a more
              competitive offer,{" "}
              <span className={styles.link}>we’ll beat it</span>.
            </p>
          </div>
          <div className={styles.buttons}>
            <DoubleButton />
          </div>
        </div>
      </div>
    </section>
  )
}

export default PriceGuaranteedHomepage
